import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Button from './Button';

const SelectList = ({ data, onSelect }) => {

  const handleSelect = (selected) => e => {
    e.preventDefault()
    onSelect(selected)
  }

  return (
    <ul className="m-auto flex flex-col items-center justify-center">
      {Object.values(data).map(item => {
        return (
          <SelectList.Item key={`SelectList${get(item, 'id')}`} id={get(item, 'id')}>
            <Button onClick={handleSelect(item)} type="button" className="!bg-transparent border-2 border-gray-300 px-10 py-10">
              <b className="text-primary ">{get(item, 'attributes.name')}</b>
            </Button>
          </SelectList.Item>
        )
      })}
    </ul>
  )
}

SelectList.defaultProps = {
  data: [],
  onSelect: () => {}
}

SelectList.propTypes = {
  data: PropTypes.instanceOf(Object),
  onSelect: PropTypes.instanceOf(Function)
}

SelectList.Item = ({ id, children }) => {
  return (
    <li className="text-center w-full">
      {children}
    </li>
  )
}

SelectList.Item.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
}

export default SelectList